module.exports = __webpack_public_path__ + "media/images/benin-b5d817e45b138b3a66e318bdaec4a48e.png";